module.exports = __webpack_public_path__ + "img/colours-nav.812daa8a.png";